module.exports = __webpack_public_path__ + "static/media/cuhk_clst.e62d23a1.png";